import { BRAND_COLORS } from '../types/index.ts';

// Shared fill-ratio banding for the Load Deck gauges.
// Thresholds mirror the original ResultsDisplay logic (80 / 60 / 40).
// Vivid colors live in bars/markers/voxels; the *Text variants are the
// AA-safe tints used for numerals and labels (see design watchouts).
export type FillBand = 'high' | 'mid' | 'low' | 'poor';

export function fillBand(u: number): FillBand {
  if (u >= 80) return 'high';
  if (u >= 60) return 'mid';
  if (u >= 40) return 'low';
  return 'poor';
}

// Vivid color for bars / markers / voxels (never text).
export function fillBarColor(u: number): string {
  const b = fillBand(u);
  if (b === 'high') return BRAND_COLORS.green;
  if (b === 'poor') return BRAND_COLORS.red;
  return BRAND_COLORS.amber;
}

// AA-safe darkened tint for numerals / labels on light surfaces.
export function fillTextColor(u: number): string {
  const b = fillBand(u);
  if (b === 'high') return BRAND_COLORS.greenText;
  if (b === 'poor') return BRAND_COLORS.redText;
  return BRAND_COLORS.amberText;
}
